import React, { PropsWithChildren, PureComponent } from 'react';

import Box from '../atoms/Box/Box';
import Text from '../atoms/Text/Text';

type AccountTitleProps = {
  className?: string;
};

class AccountTitle extends PureComponent<PropsWithChildren<AccountTitleProps>> {
  render() {
    const { className, children } = this.props;

    return (
      <Box className={className} smMl={1} smMr={1} smMb={1.375} mb={2.25}>
        <Text smSize={2} size={2.25} weight="bold" color="cornflowerBlue">
          {children}
        </Text>
      </Box>
    );
  }
}

export default AccountTitle;
